var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPrematchMatches = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1997 8H0.199707V0.888889C0.199707 0.4 0.599707 0 1.0886 0H15.3108C15.7997 0 16.1997 0.4 16.1997 0.888889V8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1997 8.88892H0.199707V9.33336C0.199707 9.82225 0.599707 10.2222 1.0886 10.2222H15.3108C15.7997 10.2222 16.1997 9.82225 16.1997 9.33336V8.88892Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75488 13.3333H12.6438V12.8889C12.6438 12.4 12.2438 12 11.7549 12H4.64377C4.15488 12 3.75488 12.4 3.75488 12.8889V13.3333Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19971 10.2224V12.0002",
    stroke: "#fff",
    strokeWidth: 2.286,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPrematchMatches);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_prematch_matches.d1cc38a0c6f645c5a6404b7adab2f6e6.svg";